/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';
import { FacilityGroupNotificationSettingDto } from '../../models/facility-group-notification-setting-dto';

export interface UpdateSetting_3$Params {
  settingId: number;
      body: FacilityGroupNotificationSettingDto
}

export function updateSetting_3(http: HttpClient, rootUrl: string, params: UpdateSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroupNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, updateSetting_3.PATH, 'put');
  if (params) {
    rb.path('settingId', params.settingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroupNotificationSetting>;
    })
  );
}

updateSetting_3.PATH = '/api/facilityGroup/notification/setting/{settingId}';
